import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {deleteWord} from '../../../modules/admin/voca';
import styles from './styles/vocaDeleteModal.module.css';

export default function VocaDeleteModal({ setIsOpenModal, deleteVoca, category }) {
    const dispatch = useDispatch();

    const {deleteResponse, deleteErrorResponse} = useSelector(({voca}) => ({
        deleteResponse: voca.deleteResponse,
        deleteErrorResponse: voca.deleteErrorResponse
    }));

    const [isDisplayOnce, setIsDisplayOnce] = useState(false);
    const [userConfirm, setUserConfirm] = useState(false);

    // not working
    const onChangeCheckbox = (state) => {
        setIsDisplayOnce(state);
    }

    const handleDelete = () => {
        setUserConfirm(true);
        dispatch(deleteWord({ category, deleteVoca }));
    };

    useEffect(() => {
        if (userConfirm && deleteResponse) {
            setIsOpenModal(false);
        }
    }, [deleteResponse, deleteErrorResponse]);

    return (
        <div>
            <div className={styles.containerModal}>
                <div>
                    <h1 className={styles.header}>해당 단어를 삭제하시겠습니까?</h1>
                    <p className={styles.subInfo} style={ deleteErrorResponse && {display: 'none'}}>삭제된 항목은 복구할 수 없습니다.</p>
                    <p className={styles.errorInfo} style={ !deleteErrorResponse && { display: 'none' }}>단어 삭제에 실패했습니다. 다시 시도해 주세요.</p>
                </div>
                <div className={styles.containerUserActions}>
                    <div className={styles.containerCheck}>
                        {/* <input id="display-once" type="checkbox" checked={isDisplayOnce} onChange={e => onChangeCheckbox(e.target.checked)}/>
                        <label htmlFor="display-once">다신 보지 않기</label> */}
                    </div>
                    <div className={styles.buttonArea}>
                        <button className={styles.buttonCancel} onClick={e => setIsOpenModal(false)}>취소</button>
                        <button className={styles.buttonConfirm} onClick={handleDelete}>삭제하기</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
